import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=57d40d44&scoped=true&"
import script from "./terms.vue?vue&type=script&lang=js&"
export * from "./terms.vue?vue&type=script&lang=js&"
import style0 from "./terms.vue?vue&type=style&index=0&id=57d40d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d40d44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d40d44')) {
      api.createRecord('57d40d44', component.options)
    } else {
      api.reload('57d40d44', component.options)
    }
    module.hot.accept("./terms.vue?vue&type=template&id=57d40d44&scoped=true&", function () {
      api.rerender('57d40d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/terms.vue"
export default component.exports